/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createChartStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '460px',
      border: '1px solid #EEEEEE',
      borderRadius: '12px',
      padding: '24px 24px 0',
      margin: '0 0 24px',
    },
    skeletonOffset: {
      marginBottom: '20px',
    },
    noData: {
      padding: '20px 0',
    },
    alignCenter: {
      textAlign: 'center',
    },
  }),
);

export { createChartStyles };
